/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateChallengeEntitlementDto
 */
export interface CreateChallengeEntitlementDto {
    /**
     * Challenge category ID this entitlement belongs to
     * @type {string}
     * @memberof CreateChallengeEntitlementDto
     */
    'challengeCategoryId': string;
    /**
     * Name of the entitlement
     * @type {string}
     * @memberof CreateChallengeEntitlementDto
     */
    'name': string;
    /**
     * Description of the entitlement
     * @type {string}
     * @memberof CreateChallengeEntitlementDto
     */
    'description'?: string;
    /**
     * Whether this entitlement is required (automatically added) or optional
     * @type {boolean}
     * @memberof CreateChallengeEntitlementDto
     */
    'isOptional': boolean;
    /**
     * Price amount for this entitlement
     * @type {number}
     * @memberof CreateChallengeEntitlementDto
     */
    'priceAmount': number;
    /**
     * Remaining quantity available for this entitlement (0 = discontinued)
     * @type {number}
     * @memberof CreateChallengeEntitlementDto
     */
    'remainingQuantity': number;
    /**
     * Whether this entitlement has unlimited quantity available
     * @type {boolean}
     * @memberof CreateChallengeEntitlementDto
     */
    'isUnlimited': boolean;
    /**
     * Array of image URLs for this entitlement
     * @type {Array<string>}
     * @memberof CreateChallengeEntitlementDto
     */
    'imageUrls'?: Array<string>;
    /**
     * Display order for sorting entitlements in UI
     * @type {number}
     * @memberof CreateChallengeEntitlementDto
     */
    'displayOrder': number;
    /**
     * Type of entitlement
     * @type {string}
     * @memberof CreateChallengeEntitlementDto
     */
    'type': CreateChallengeEntitlementDtoTypeEnum;
}

export const CreateChallengeEntitlementDtoTypeEnum = {
    Physical: 'physical',
    Digital: 'digital'
} as const;

export type CreateChallengeEntitlementDtoTypeEnum = typeof CreateChallengeEntitlementDtoTypeEnum[keyof typeof CreateChallengeEntitlementDtoTypeEnum];


